//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, ConciergeProxy, SagasHelper, LogsProxy } from 'com-gyf-webcore-servicehub';

//import UsuarioManager from '../../../Common/Managers/UsuarioManager';

//Exportaci�n de constantes
export const SET_FUNCTIONS_VISTA_DE_USUARIOS = 'SET_FUNCTIONS_VISTA_DE_USUARIOS';
export const GET_DATA_VISTA_USUARIOS_START = 'GET_DATA_VISTA_USUARIOS_START';
export const GET_DATA_VISTA_USUARIOS_SUCCESS = 'GET_DATA_VISTA_USUARIOS_SUCCESS';
export const SET_SELECTED_USER_ID = 'SET_SELECTED_USER_ID';
export const GET_DATA_ESTADO_USUARIOS_SUCCESS = 'GET_DATA_ESTADO_USUARIOS_SUCCESS';
export const SET_INGRESA_MOTIVO_BLOQUEADO = 'SET_INGRESA_MOTIVO_BLOQUEADO';
export const RESET_STATE_VISTA_USUARIOS = 'RESET_STATE_VISTA_USUARIOS';
export const GET_DATA_AD_VISTA_USUARIOS = 'GET_DATA_AD_VISTA_USUARIOS';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _currentScope, _selectedUserId = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} selectedUserId
 * @param {any} currentScope
 */
export function getData(selectedUserId, currentScope) {
    LogHelper.In(getData.name, selectedUserId, currentScope);

    return (dispatch, getState) => {
        const state = getState();
        _dispatch = dispatch;
        _currentScope = currentScope;
        _selectedUserId = selectedUserId;

        dispatch({ type: SET_SELECTED_USER_ID, state, selectedUserId: selectedUserId });
        dispatch({ type: GET_DATA_VISTA_USUARIOS_START, state, currentUser: _currentScope.UserId });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => getFunctionsCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Setea el estado del usuario.
 * @param {any} id
 * @param {any} activo
 * @param {any} bloqueado
 */
export function setUserState(id, activo, bloqueado) {
    LogHelper.In(setUserState.name, id, activo, bloqueado);

    let caseActive;
    let ruleName;
    let localvaluesUpdateUsuarioEstado;
    let localvaluesDeleteBlockUnblockUsuario;
    let usuariosToDeleteBlockUnblock = [];
    let usuariosToUpdateState = [];

    return (dispatch, getState) => {
        const state = getState();

        if (activo == false) {
            if (bloqueado == false) { caseActive = 1; }
            else { caseActive = 3; }
        } else { if (bloqueado == false) { caseActive = 2; } }

        localvaluesUpdateUsuarioEstado = {
            //"ID": id,
            "USUARIO_ID": id,
            "ACTIVO": activo
        }

        switch (caseActive) {
            case 1: {
                ruleName = "DeleteUsuario";
         
                localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id, "CURRENT_USER": state.vistaDeUsuario.currentUser, "FECHA_ELIMINADO": null }
                break;
            }
            case 2: {
                ruleName = "UnlockUsuario";
         
                localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id }
                break;
            }
            case 3: {
                ruleName = "LockUsuario";
         
                localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id, "CURRENT_USER": state.vistaDeUsuario.currentUser, "FECHA_BLOQUEADO": null }
                break;
            }
            default: {
                break;
            }
        }

        LogHelper.Out(setUserState.name, /*{ UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }*/
            localvaluesDeleteBlockUnblockUsuario, ruleName, _currentScope.ProductCode, "SEGURIDAD");
        Engine1Proxy.AddRuleRequests(/*{ UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }*/
            localvaluesDeleteBlockUnblockUsuario, ruleName, _currentScope.ProductCode, "SEGURIDAD");

        LogHelper.Out(setUserState.name, /*{ UsuariosToUpdateState: usuariosToUpdateState }*/
            localvaluesUpdateUsuarioEstado, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");
        Engine1Proxy.AddRuleRequests(/*{ UsuariosToUpdateState: usuariosToUpdateState }*/
            localvaluesUpdateUsuarioEstado, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");

        let tempList = [];
        tempList.push(localvaluesDeleteBlockUnblockUsuario);

        Engine1Proxy.Execute((data) => setUserStateCallback(data, tempList, ruleName, state.vistaDeUsuario.usuario), null, null, "SEGURIDAD");
    }
}

/**
 * Setea el motivo de bloqueo del usuario.
 * @param {any} usuarioId
 * @param {any} motivoBloqueo
 */
export function setMotivoBloqueo(usuarioId, motivoBloqueo) {
    LogHelper.In(setMotivoBloqueo.name, usuarioId, motivoBloqueo);

    return (dispatch, getState) => {
        const state = getState();

        let usuariosToEdit = [];

        let localvalues = {
            'USUARIO_ID': usuarioId,
            'MOTIVO_BLOQUEO': motivoBloqueo,
        }

        LogHelper.Out(setMotivoBloqueo.name, localvalues, "UpdateUsuarioMotivoBloqueo", _currentScope.ProductCode, "SEGURIDAD");
        Engine1Proxy.AddRuleRequests(localvalues, "UpdateUsuarioMotivoBloqueo", _currentScope.ProductCode, "SEGURIDAD");
        Engine1Proxy.Execute(setMotivoBloqueoCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Resetea el estado inicial
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: RESET_STATE_VISTA_USUARIOS });
    }
}

/**--------------------------- FUNCIONES AUXILIARES ----------------------------**/

/**
 * Funcion callback de la obtencion de las funciones del usuario.
 * @param {any} data
 */
function getFunctionsCallback(data) {
    LogHelper.In(getFunctionsCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_FUNCTIONS_VISTA_DE_USUARIOS, functions });

    if (functions.Consulta == true) {
        var localvalues = {
            'USUARIO_ID': _selectedUserId
        }

        Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_USUARIO_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_PERFIL_USUARIO', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_MODO_EXCLUSIVO_BY_USER_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_CANLOG_BY_USUARIO_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_LOG_PLATAFORMA_BY_USUARIO_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_CONFIGURATION_PASSWORD_TYPE", "Get", _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);

        localvalues = {
            'PRODUCTO_ID': null,
            'CATEGORIA_ID': null,
            'PROGRAMA_ID': null, 
            'USUARIO_ID': _selectedUserId
        }

        //TODO: Analizar como hacer el Out de estas situaciones.
        LogHelper.Out(getFunctionsCallback.name, localvalues, 'GET_PERMISOS_BY_USUARIO', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_PERMISOS_BY_USUARIO', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
        Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Funcion callback de la obtencion de los datos principales para popular la pantalla.
 * @param {any} data
 */
function getDataCallback(data) {
    LogHelper.In(getDataCallback.name, data);

    let result = null;

    result = {
        'USUARIO': JSON.parse(data.GET_USUARIO_BY_ID).Recordset0.Rows != undefined ? JSON.parse(data.GET_USUARIO_BY_ID).Recordset0.Rows : null,
        'PERFILES': JSON.parse(data.GET_PERFIL_USUARIO).Recordset0.Rows != undefined ? JSON.parse(data.GET_PERFIL_USUARIO).Recordset0.Rows : null,
        'PERMISOS': JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset0.Rows != undefined ? JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset0.Rows : null,
        'PERMISOS_PARA_MOSTRAR': JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset1.Rows != undefined ? JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset1.Rows : null,
        'MODO_EXCLUSIVO': JSON.parse(data.GET_MODO_EXCLUSIVO_BY_USER_ID).Recordset0.Rows != undefined ? JSON.parse(data.GET_MODO_EXCLUSIVO_BY_USER_ID).Recordset0.Rows : null,
        'ACCESOS_SIMULTANEOS': JSON.parse(data.GET_CANLOG_BY_USUARIO_ID).Recordset0.Rows != undefined ? JSON.parse(data.GET_CANLOG_BY_USUARIO_ID).Recordset0.Rows : null,
        'ULTIMO_INGRESO': JSON.parse(data.GET_LOG_PLATAFORMA_BY_USUARIO_ID).Recordset0.Rows != undefined ? JSON.parse(data.GET_LOG_PLATAFORMA_BY_USUARIO_ID).Recordset0.Rows : null,
        'INGRESA_MOTIVO_BLOQUEADO': true,
        'ESTADO_ACTUAL': null,
        'CONFIGURATION_PASSWORD_TYPE': JSON.parse(data.GET_CONFIGURATION_PASSWORD_TYPE).Recordset0.Rows[0],
        'GRUPOS_WINDOWS': []
    }

    if (result.CONFIGURATION_PASSWORD_TYPE.VincularGrupoWindows == true && result.CONFIGURATION_PASSWORD_TYPE.TipoSeguridad == "AD") {
        //Grupos AD
        let localvalues = { "USUARIO": (result.USUARIO[0].Login_NT) ? result.USUARIO[0].Login_NT : "" };

        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_GROUPS_BY_USER_AD", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "User", true);

        LogHelper.Out(getDataCallback.name);
        Engine1Proxy.Execute(getDataCallbackADGroups, null, null, "SEGURIDAD");
    }

    let estadoActual = null;

    if (result.USUARIO[0].Activo == true && result.USUARIO[0].Bloqueado == false && result.USUARIO[0].Bloqueado_Inactividad == false) {
        estadoActual = 'ACTIVO';
    }
    else if ((result.USUARIO[0].Activo == false && result.USUARIO[0].Bloqueado == true) ||  result.USUARIO[0].Bloqueado_Inactividad == true) {
        estadoActual = 'BLOQUEADO';
    }
    else if (result.USUARIO[0].Activo == false && result.USUARIO[0].Bloqueado == false &&  result.USUARIO[0].Bloqueado_Inactividad == false) {
        estadoActual = 'ELIMINADO';
    }

    result.ESTADO_ACTUAL = estadoActual;

    _dispatch({ type: GET_DATA_VISTA_USUARIOS_SUCCESS, result });
}

/**
 * Funcion callback de la obtenci�n de grupos AD del usuario a editar
 * @param {any} data
 */
function getDataCallbackADGroups(data) {
    //Valido si hubo error en la consulta de AD.
    let ADResult = JSON.parse(data.GET_GROUPS_BY_USER_AD).Recordset0.Rows[0];
    let gruposWindows = [];

    if (ADResult.IsError) {
        gruposWindows = [{ nombre: 'Hubo un error al consultar la informaci�n AD' }];
    }
    else {
        //Mapeo de grupos de AD.        
        ADResult = JSON.parse(ADResult.Result);
        ADResult.forEach((g) => {
            gruposWindows.push({ nombre: g });
        });
    }

    _dispatch({ type: GET_DATA_AD_VISTA_USUARIOS, gruposWindows });
}

/**
 * Funcion callback del cambio de estado de un usuario.
 * @param {any} data
 */
function setUserStateCallback(data, userListSelected, ruleName, usuario) {
    LogHelper.In(setUserStateCallback.name, data);

    var localvalues = {
        'USUARIO_ID': _selectedUserId
    }

    LogUserState(userListSelected, ruleName, usuario);

    LogHelper.Out(setUserStateCallback.name, localvalues, 'GET_USUARIO_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
    Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_USUARIO_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
    Engine1Proxy.Execute(getDataUserStateCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion callback del seteo de motivo de bloqueo de un usuario.
 * @param {any} data
 */
function setMotivoBloqueoCallback(data) {
    LogHelper.In(setMotivoBloqueoCallback.name, data);

    //Activa el flag que muestra o no el dropdown para ingresar motivo de bloqueo
    //_dispatch({ type: SET_INGRESA_MOTIVO_BLOQUEADO, ingresaMotivoBloqueado: false });

    var localvalues = {
        'USUARIO_ID': _selectedUserId
    }

    LogHelper.Out(setMotivoBloqueoCallback.name, localvalues, 'GET_USUARIO_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
    Engine1Proxy.AddDataSourcesRequests(localvalues, 'GET_USUARIO_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", 1, 'User');
    Engine1Proxy.Execute(getDataUserStateCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion callback del cambio de estado de un usuario.
 * @param {any} data
 */
function getDataUserStateCallback(data) {
    LogHelper.In(getDataUserStateCallback.name, data);

    let result = null;

    result = {
        'USUARIO': JSON.parse(data.GET_USUARIO_BY_ID).Recordset0.Rows != undefined ? JSON.parse(data.GET_USUARIO_BY_ID).Recordset0.Rows : null
    }

    let estadoActual = null;
    if (result.USUARIO[0].Activo == true && result.USUARIO[0].Bloqueado == false) {
        estadoActual = 'ACTIVO';
    } else if (result.USUARIO[0].Activo == false && result.USUARIO[0].Bloqueado == true) {
        estadoActual = 'BLOQUEADO';
    } else if (result.USUARIO[0].Activo == false && result.USUARIO[0].Bloqueado == false) {
        estadoActual = 'ELIMINADO';
    }

    result.ESTADO_ACTUAL = estadoActual;

    _dispatch({ type: GET_DATA_ESTADO_USUARIOS_SUCCESS, result });
}

/**
 * 
 * @param {any} userListSelected
 * @param {any} ruleName
 * @param {any} userData
 */
function LogUserState(userListSelected, ruleName, userData) {
    let action = null;
    let tags = null;

    userListSelected.forEach(function (user) {
        switch (ruleName) {
            case "DeleteUsuario":
                tags = "SEGURIDAD,BAJA,USUARIO";
                action = "Eliminaci�n del Usuario " + userData.Login + " - " + userData.Nombre + " ; de la Sucursal: " + userData.Sucursal + " " + " ; del Sector:  " + userData.Sector;
                break;

            case "UnlockUsuario":

                if (userData.FechaEliminado) {
                    tags = "SEGURIDAD,REACTIVACION,USUARIO";
                    action = "Reactivaci�n del Usuario " + userData.Login + " - " + userData.Nombre + " ; de la Sucursal: " + userData.Sucursal + " " + " ; del Sector:  " + userData.Sector;
                } else {
                    tags = "SEGURIDAD,DESBLOQUEO,USUARIO";
                    action = "Desbloqueo del Usuario " + userData.Login + " - " + userData.Nombre + " ; de la Sucursal: " + userData.Sucursal + " " + " ; del Sector:  " + userData.Sector;
                }

                break;

            case "LockUsuario":
                tags = "SEGURIDAD,BLOQUEO,USUARIO";
                action = "Bloqueo del Usuario " + userData.Login + " - " + userData.Nombre + " ; de la Sucursal: " + userData.Sucursal + " " + " ; del Sector:  " + userData.Sector;
                break;
        }

        LogsProxy.SaveOperationLog(tags, action, null, null, null, null, null, "SEGURIDAD");
    })
}